export default __webpack_public_path__ + "static/phone-f0390604ebbebe55efe7d48f4fc3eb39.png";